module.exports = __webpack_public_path__ + "static/nodejs.b61fb0bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/nodejs.svg
// module id = 744
// module chunks = 263791100135453